module.exports = __webpack_public_path__ + "img/geography.ef81d8d6.png";